import React, { useState } from "react";
import { HiArrowSmUp, HiArrowSmDown } from "react-icons/hi";
import LoginDialog from "components/card/LoginDialog";
import VerifyEmailDialog from "components/card/VerifyEmailDialog";

const VoteButtons = ({
  currentUser,
  state = "",
  onChange,
  isDisabled,
  leftText = "ոչ",
  rightText = "այո",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenVerifyEmailDialog, setIsOpenVerifyEmailDialog] = useState(false);
  const [agreeHovered, setAgreeHovered] = useState(false);
  const [disagreeHovered, setDisagreeHovered] = useState(false);

  // Active state — show the label, expand to full width
  const activeDisagreeClass = "w-[120px] sm:w-[160px] text-red-300";
  const activeAgreeClass = "w-[120px] sm:w-[160px] text-cyan-300";

  // Inactive state — collapsed, expands on hover
  const inactiveDisagreeClass =
    "w-[44px] hover:w-[120px] sm:hover:w-[160px] text-slate-500 hover:text-red-400";
  const inactiveAgreeClass =
    "w-[44px] hover:w-[120px] sm:hover:w-[160px] text-slate-500 hover:text-cyan-300";

  const inactiveTextClass =
    "absolute opacity-0 group-hover:opacity-100 group-hover:relative";

  const handleDisagreeClick = () => {
    if (!currentUser) {
      setIsOpen(true);
      return;
    }
    if (currentUser && !currentUser.emailVerified) {
      if (currentUser.providerData?.[0].providerId !== "facebook.com") {
        setIsOpenVerifyEmailDialog(true);
        return;
      }
    }
    if (!isDisabled) onChange("disagree");
  };

  const handleAgreeClick = () => {
    if (!currentUser) {
      setIsOpen(true);
      return;
    }
    if (currentUser && !currentUser.emailVerified) {
      if (currentUser.providerData?.[0].providerId !== "facebook.com") {
        setIsOpenVerifyEmailDialog(true);
        return;
      }
    }
    if (!isDisabled) onChange("agree");
  };

  return (
    <div className="flex justify-end items-center shrink-0">
      <div className="flex items-center bg-slate-100 dark:bg-slate-800/80 p-1 sm:p-1.5 px-2.5 sm:px-3 rounded-full border border-slate-200/80 dark:border-slate-700/60 shadow-sm gap-1.5 sm:gap-2 text-slate-700 dark:text-slate-300">
        {/* Disagree button */}
        <button
          title={isDisabled ? "Քվեարկությունը ավարտված է" : "Համաձայն չեմ"}
          onClick={handleDisagreeClick}
          disabled={isDisabled}
          className={`flex items-center gap-0.5 sm:gap-1 hover:text-red-500 transition-colors ${state === "disagree" ? "text-red-500 font-bold" : ""
            }`}
        >
          <HiArrowSmDown size={18} className={state === "disagree" ? "text-red-500" : "text-slate-600 dark:text-slate-400"} />

          <span className="text-[10px] sm:text-xs font-bold uppercase">{leftText}</span>

        </button>

        <span className="text-slate-300 dark:text-slate-600 text-xs sm:text-sm font-light select-none">|</span>

        {/* Agree button */}
        <button
          title={isDisabled ? "Քվեարկությունը ավարտված է" : "Համաձայն եմ"}
          onClick={handleAgreeClick}
          disabled={isDisabled}
          className={`flex items-center gap-0.5 sm:gap-1 hover:text-[#0033FF] transition-colors ${state === "agree" ? "text-[#0033FF] font-bold" : ""
            }`}
        >
          <HiArrowSmUp size={18} className={state === "agree" ? "text-[#0033FF]" : "text-slate-600 dark:text-slate-400"} />

          <span className="text-[10px] sm:text-xs font-bold uppercase">{rightText}</span>

        </button>
      </div>

      <LoginDialog isOpen={isOpen} handleClose={() => setIsOpen(false)} />
      <VerifyEmailDialog
        isOpen={isOpenVerifyEmailDialog}
        handleClose={() => setIsOpenVerifyEmailDialog(false)}
      />
    </div>
  );
};

export default VoteButtons;
